// const API_BASE_URL = "http://localhost:5000/";
const API_BASE_URL = "https://exam-api.sbmranchi.org/";

export const roleAccess = {
  Head: ["/dashboard", "/exam-master", "/grade-master", "/subject-master"],
  Exam: [
    "/dashboard",
    "/marks-entry",
    "/exam-wise-report",
    "/half-yearly-report",
  ],
};

export default API_BASE_URL;
